import dedent from 'dedent';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import styled from 'styled-components';

import TextAreaField from 'dashboard/components/FormControls/TextAreaField';
import Button from 'design-system/components/Button';

const SaveButton = styled(Button)`
  width: 30%;
  min-width: 190px;
`;

const StyledTextAreaField = styled(TextAreaField)`
  textarea {
    font-size: ${({ theme }) => theme.text.paragraph.md.fontSize};
    font-family: ${({ theme }) => theme.text.fontFamily.mono};
  }
`;

const FormSamlMetadataXmlComponent = (props: InjectedFormProps<{}, {}>) => {
  const { pristine, submitting } = props;

  return (
    <form onSubmit={props.handleSubmit}>
      <Field
        rows={10}
        name='metadataXml'
        id='metadataXml'
        component={StyledTextAreaField}
        placeholder={dedent`
          <?xml version="1.0" encoding="UTF-8"?>
          <md:EntityDescriptor xmlns:md="urn:oasis:names:tc:SAML:2.0:metadata" entityID="http://www.okta.com/abcdefg">
            ...
          </md:EntityDescriptor>
        `}
        label='Provide the raw Metadata XML IdP details.'
      />
      <SaveButton type='submit' disabled={pristine || submitting} isPending={submitting}>
        Parse metadata
      </SaveButton>
    </form>
  );
};

const FormSamlMetadataXml = reduxForm<FormSamlMetadataXmlData, {}>({
  form: 'samlMetadataXml',
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormSamlMetadataXmlComponent);

export interface FormSamlMetadataXmlData {
  metadataXml: string;
}

export default FormSamlMetadataXml;
